module.exports = __webpack_public_path__ + "img/login_logo.653c4da7.png";